let _userId: string | null = null;

/**
 * Called once at app bootstrap (index.tsx) after MSAL authentication resolves.
 * Must be called before React renders — all localStorage hooks depend on this.
 */
export function setCurrentUserId(userId: string): void {
  _userId = userId;
}

/**
 * Returns the current user's ID for scoping localStorage keys.
 * Throws if called before setCurrentUserId — this is a programming error
 * since the app should not render before authentication completes.
 */
export function getCurrentUserId(): string {
  if (!_userId) {
    throw new Error(
      "getCurrentUserId called before setCurrentUserId. " +
        "Ensure setCurrentUserId is called in index.tsx before startApplication()."
    );
  }
  return _userId;
}
